
import { defineComponent } from "vue";
import { contentsService, StaticContent } from "@/services/contents.service";

export default defineComponent({
  name: "LaunchYourProduct",
  components: {},
  data() {
    return {
      page: undefined as StaticContent | undefined,
    };
  },
  mounted() {
    contentsService.findBySlug("page-launch-your-product").then((page) => {
      this.page = page as StaticContent;
    });
  },
});
